import React from 'react';
import { ExternalLink } from 'lucide-react';
import { content } from '../config/site.js';

export default function Store({ lang }) {
  const t = content[lang].store;

  return (
    <section className="section reveal" id="store">
      <div className="store-panel surface reveal">
        <div>
          <span className="section-label">{t.label}</span>
          <h2>{t.title}</h2>
          <p>{t.text}</p>
        </div>
        <div className="store-actions">
          <a className="primary-action" href="/topup">{t.primary} <ExternalLink size={17} /></a>
          <a className="secondary-action" href="/rules">{t.secondary}</a>
        </div>
      </div>
    </section>
  );
}
